var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productlabel)?_c('div',{staticClass:"label-overlay"},[_c('div',{class:_vm.CalcLabelPosition(_vm.productlabel.position)},[_c('span',{style:(_vm.parseStyle(_vm.productlabel.css))},[_vm._v(_vm._s(_vm.productlabel.text))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }